var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDoneStatus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 4.07825e-05C15.5228 4.07825e-05 20 4.4772 20 10C20 15.5228 15.5228 20 10 20C4.4772 20 4.14787e-05 15.5228 4.14787e-05 10C-0.0156734 4.49286 4.43598 0.0157556 9.94309 4.07825e-05C9.96207 -1.35942e-05 9.98104 -1.35942e-05 10 4.07825e-05Z",
    fill: "#3BB54A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5397 7.24422L8.43742 14.3465L4.46014 10.3976L6.07948 8.80673L8.43742 11.1363L13.9204 5.65332L15.5397 7.24422Z",
    fill: "#D4E1F4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoneStatus);
export default __webpack_public_path__ + "static/media/done-status.ad2ae130278fb074e698c1e08a11f843.svg";
export { ForwardRef as ReactComponent };